import { Sparkles, ShoppingCart } from "lucide-react";
import { Button } from "./ui/button";
import { useNavigate } from "react-router-dom";
import { detectUserCurrency, CURRENCY_SYMBOLS, PRICE_AMOUNTS } from "@/lib/stripe-prices";

interface PremiumCreditsDisplayProps {
  hasPremium: boolean;
  creditsRemaining: number;
  loading?: boolean;
}

export const PremiumCreditsDisplay = ({ 
  hasPremium, 
  creditsRemaining, 
  loading = false 
}: PremiumCreditsDisplayProps) => {
  const navigate = useNavigate();
  const currency = detectUserCurrency();

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Sparkles className="w-4 h-4 animate-pulse" />
        <span>Verificando créditos...</span>
      </div>
    );
  }

  if (!hasPremium || creditsRemaining === 0) {
    return (
      <Button
        variant="default"
        size="sm"
        onClick={() => navigate("/camera")}
        className="gap-2"
      >
        <ShoppingCart className="w-4 h-4" />
        Comprar Premium - {CURRENCY_SYMBOLS[currency]}{PRICE_AMOUNTS[currency].toFixed(2)} (77 avaliações)
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-lg">
      <Sparkles className="w-4 h-4 text-primary" />
      <span className="text-sm font-medium text-primary">
        Premium Ativo - {creditsRemaining} avaliações restantes
      </span>
    </div>
  );
};
